<template>
  <div :class="size" class="grid place-items-center">
    <UserCircle class="rounded-full text-gray-500 w-5 h-5" v-if="!user" />
    <img
      :class="[
        size,
        {
          'ring-2 ring-white': withRing,
        },
      ]"
      class="relative inline-block rounded-full object-cover align-baseline"
      :src="user.avatar_url"
      alt=""
      v-else-if="user.avatar_url"
    />
    <div
      :class="[size, background]"
      class="flex items-center justify-center rounded-full"
      v-else
    >
      <div class="text-xs font-medium text-gray-600 uppercase">
        {{ user.avatar_initials }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, defineProps } from "vue";
import UserCircle from "@/Tailwind/Icon/UserCircle.vue";

const props = defineProps({
  user: Object,
  size: Number,
  backgroundColor: String,
  withRing: { type: Boolean, default: true },
});

const size = computed(() => {
  if (props.size) {
    return `w-${props.size} h-${props.size}`;
  }

  return "h-6 w-6";
});

const background = computed(() => {
  if (props.backgroundColor) {
    return `bg-${props.backgroundColor} border-gray-300 border`;
  }

  return "bg-gray-100";
});
</script>
